import React, { useEffect, useState } from "react";
import "./FanEngagementTypeComponent.css";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { APIUrl, APIUrlToken, getIsUser } from "../../Utils/Utils";
import axios from "axios";
import { FaUser } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { toast } from "react-toastify";

const FanEngagementTypeComponent = () => {
  const [step, setStep] = useState(1);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [specialInstructions, setSpecialInstructions] = useState("");
  const [selectedPricing, setSelectedPricing] = useState("");
  const [multipleRequests, setMultipleRequests] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const {
    playerId,
    teamId,
    playerName,
    pricingOptionsList,
    dataFanExperience,
  } = location.state || {};
  
  const assignedAmount = location.state?.sectionValue;
  const [assignedAmountNav] = useState(assignedAmount);

  const engagementTypeFromNav = location.state?.type || "generalsupport";
  const [fanEngagementTypeNavigate] = useState(engagementTypeFromNav);
  const fanEngagementTypePay =
    location.state?.checkoutType || "sponsoredSocialMediaPost";
  const [brandEngagementTypeNavigate] = useState(fanEngagementTypePay);
  const [totalAmountCheckout, setTotalAmountCheckout] = useState("");

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    phoneno: "",
    email: "",
  });
  // ---------------- Fan Experience Data -----------------

  useEffect(() => {}, [pricingOptionsList]);
  // ---------------- Dynamic Data Based on Type -----------------
  const selectedFanTypeData = dataFanExperience.find(
    (item) => item.fanEngagementType === fanEngagementTypeNavigate
  );

  const SocialMediaPlatform = selectedFanTypeData?.platforms || [];
  const FanEngagementDetails = {
    description: selectedFanTypeData?.description || "",
    example: selectedFanTypeData?.example || "",
    label: selectedFanTypeData?.specialInstructionsLabel || "Enter details:",
  };
  const PricingOptions = selectedFanTypeData?.pricingOptions || [];

  const CheckoutPayment = {
    description:
      "Include full name, review or edit selections, and checkout via credit card.",
  };

  const steps = [
    "Select Social Media Platform",
    "Provide Details of Fan Engagement",
    "Checkout Details & Payment",
  ];

  const nextStep = () => {
    if (step < steps.length) setStep(step + 1);
    if (step === 3) {
      handleSubmitFanEngagement();
    }
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  const handlePricingSelect = (option) => {
    setSelectedPricing(option);
    if (option !== "Multiple Requests (please specify)") {
      setMultipleRequests("");
    }
  };

  const progressWidth = `${(step / steps.length) * 100}%`;

  const isNextDisabled =
    (step === 1 && !selectedPlatform) ||
    (step === 2 && !specialInstructions.trim());

  const getStepContent = () => {
    switch (step) {
      case 1:
        return (
          <div className="fan-step">
            <h3>{steps[0]}</h3>
            <div className="fan-platforms">
              {SocialMediaPlatform.map((platform, index) => (
                <label key={index} className="fan-option">
                  <input
                    type="radio"
                    name="platform"
                    value={platform}
                    checked={selectedPlatform === platform}
                    onChange={(e) => setSelectedPlatform(e.target.value)}
                  />
                  <span>{platform}</span>
                </label>
              ))}
            </div>
          </div>
        );

      case 2:
        return (
          <div className="fan-step">
            <h3>{steps[1]}</h3>
            <p className="fan-description">
              {FanEngagementDetails.description}
            </p>
            <p className="fan-example">{FanEngagementDetails.example}</p>
            <div className="fan-field">
              <label>{FanEngagementDetails.label}</label>
              <textarea
                className="fan-input"
                placeholder="Enter any special instructions..."
                value={specialInstructions}
                onChange={(e) => setSpecialInstructions(e.target.value)}
              />
            </div>
          </div>
        );

      case 3:
        return (
          <div className="fan-step">
            <h3>{steps[2]}</h3>

            {/* ---------- Primary Details ---------- */}
            {!userLoginDetails?.user_id ? (
              <>
                <div className="section-title-accountInfo">Primary Details</div>
                <div className="first-section-my-profile">
                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="firstname"
                        placeholder="First Name"
                        value={formData.firstname}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>

                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaUser />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="lastname"
                        placeholder="Last Name"
                        value={formData.lastname}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>

                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <FaPhoneAlt />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="phoneno"
                        placeholder="Phone Number"
                        value={formData.phoneno}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>

                  <div className="input-section-accountInfo">
                    <div className="input-group-accountInfo">
                      <div className="input-icon-accountInfo">
                        <MdEmail />
                      </div>
                      <input
                        type="text"
                        className="form-control-accountInfo"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={!!userLoginDetails?.user_id}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : null}

            <hr />

            {/* ---------- Requested Details ---------- */}
            <div className="section-title-accountInfo">Requested Details</div>
            <div className="fetc-st4">
              <div className="viewmore-fan-brand-athlete">
                <strong>Fan Engagement Type:</strong>{" "}
                {brandEngagementTypeNavigate}
              </div>
              <div className="viewmore-fan-brand-athlete">
                <strong>Selected Platform:</strong> {selectedPlatform}
              </div>
              <div className="viewmore-fan-brand-athlete">
                <strong>Instructions for Athlete:</strong>{" "}
                {specialInstructions || "—"}
              </div>
              {multipleRequests && (
                <div>
                  <strong>Additional Requests:</strong> {multipleRequests}
                </div>
              )}
            </div>
            <hr />
            <div className="section-title-accountInfo">Pricing Details</div>
            <div className="fetc-st4">
              <div className="viewmore-fan-brand-athlete">
                <strong>Total:</strong>{" "}
                {(() => {
                  const pricingValue = PricingOptions.find(
                    (p) => p.pricingText === selectedPricing
                  )?.pricingValue;

                  // If value starts with "$", clean it
                  if (
                    typeof pricingValue === "string" &&
                    pricingValue.startsWith("$")
                  ) {
                    return pricingValue.replace("+", "");
                  }

                  // Clean + from assignedAmountNav also (if it's a string)
                  if (typeof assignedAmountNav === "string") {
                    return assignedAmountNav.replace("+", "");
                  }

                  return assignedAmountNav;
                })()}
              </div>
            </div>

            <hr />
          </div>
        );

      default:
        return null;
    }
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  let userLoginDetails = getIsUser();

  const getNumericAmount = (value) => {
    if (!value) return 0;
    let str = String(value).trim();
    str = str.replace(/[^0-9.]/g, "");
    return Number(str) || 0;
  };

  const handleSubmitFanEngagement = () => {
    if (!userLoginDetails?.user_id) {
      if (!formData.firstname) {
        toast.error("Please enter firstname");
        return;
      }
      if (!formData.lastname) {
        toast.error("Please enter lastname");
        return;
      }
      if (!formData.phoneno) {
        toast.error("Please enter phoneno");
        return;
      }
      if (!formData.email) {
        toast.error("Please enter email");
        return;
      }
    }
    let data = {
      fan_engagement_type: fanEngagementTypeNavigate,
      social_media_platform: selectedPlatform,
      engagement_details: specialInstructions,
      message_to_athlete: multipleRequests,
      pricing_options: [
        {
          type: selectedPricing,
          amount: PricingOptions.find(
            (p) => p.pricingText === selectedPricing
          )?.pricingValue.startsWith("$")
            ? PricingOptions.find((p) => p.pricingText === selectedPricing)
                ?.pricingValue
            : assignedAmountNav,
        },
      ],
      user_id: userLoginDetails?.user_id,
      player_id: playerId,
    };
    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    } else {
      data.user_id = 0;
      data.user_first_name = formData.firstname;
      data.user_last_name = formData.lastname;
      data.user_phone_number = formData.phoneno;
      data.user_email = formData.email;
    }
    const url = `${APIUrl()}/v1/fan_engagement_request`;
    const option = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: url,
    };

    axios(option)
      .then(async (response) => {
        const data = response?.data;
        // if (
        //   Number(
        //     PricingOptions?.find(
        //       (i) => i?.pricingText === selectedPricing
        //     )?.pricingValue?.split("$")?.[1]
        //   )
        // ) {
        await handleDonationOnetime(data?.fan_engagement_request_id);
        // } else {
        //   toast.success("Your request submitted Successfully");
        //   navigate("/dashboard/start-your-fan-experience");
        // }
      })
      .catch((error) => {
        console.error("Error fetching teams data:", error);
      });
  };
  const handleDonationOnetime = async (item) => {
    const priceOption = PricingOptions.find(
      (p) => p.pricingText === selectedPricing
    )?.pricingValue;

    const amountToSend =
      getNumericAmount(priceOption) || getNumericAmount(assignedAmountNav);

    let data = {
      amount: amountToSend,
      nil_service_type: "general_contribution",
      player_id: Number(playerId),
      player_name: playerName,
      team_id: Number(teamId),
      fan_engagement_request_id: item,
      brand_engagement_request_id: 0,
    };

    if (userLoginDetails?.user_id) {
      data.user_id = userLoginDetails?.user_id;
      data.user_email = userLoginDetails?.user_email;
    }

    try {
      const url = `${APIUrl()}/v1/create-checkout-session/one_time`;
      const response = await axios.post(url, data, {
        headers: { "X-API-Key": APIUrlToken() },
      });
      window.open(response?.data?.checkout_url, "_blank");
    } catch (error) {
      
      console.error("Error creating checkout session:", error);
    }
  };

  return (
    <>
      <div
        className="arrow-go-back-fan"
        onClick={() => {
          navigate(`/FanExperience/${playerId}/${teamId}`);
        }}
      >
        <IoIosArrowRoundBack />
        Go back to Fan Experience{" "}
      </div>
      <div className="fan-container">
        <div className="fan-progress-bar">
          <div className="fan-progress-fill" style={{ width: progressWidth }} />
        </div>

        <div className="fan-content">{getStepContent()}</div>

        <div className="fan-buttons">
          <button
            className="fan-btn fan-btn-prev"
            onClick={prevStep}
            disabled={step === 1}
          >
            Previous
          </button>
          <button
            className="fan-btn fan-btn-next"
            onClick={nextStep}
            disabled={isNextDisabled}
          >
            {step === steps.length ? "Proceed to Checkout" : "Next"}
          </button>
        </div>
      </div>
    </>
  );
};

export default FanEngagementTypeComponent;
